var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('PageLoading'):_c('div',{staticClass:"main-wrap courses-page"},[_c('div',{staticClass:"bg-img",style:({
            'background-image':
                'url(' +
                require('@/assets/images/areas_bg_img_min.jpg') +
                ')',
        })}),_c('h1',[_vm._v(_vm._s(_vm.$tc('general.training_areas', 2)))]),_c('div',{staticClass:"categories-wrap"},_vm._l((_vm.areas),function(area,index){return _c('router-link',{key:index,staticClass:"category-box",attrs:{"to":{
                name: 'Courses',
                params: {
                    areaId: area.id,
                },
            }}},[_c('AreaThumb',{attrs:{"area":area}})],1)}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }